var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticStyle: { height: "90vh" } },
    [
      _c("b-loading", {
        attrs: { active: _vm.isLoading, "is-full-page": true },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column is-one-fifth" },
          [
            _c(
              "div",
              { staticClass: "mt-5 ml-5 is-flex is-flex-wrap-wrap" },
              _vm._l(_vm.consigneeTypes, function (t, i) {
                return _c(
                  "b-switch",
                  {
                    key: i,
                    staticClass: "mb-2",
                    on: {
                      input: function ($event) {
                        return _vm.toggleType(t)
                      },
                    },
                    model: {
                      value: _vm.switchStates[t],
                      callback: function ($$v) {
                        _vm.$set(_vm.switchStates, t, $$v)
                      },
                      expression: "switchStates[t]",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(t[0].toUpperCase() + t.slice(1).toLowerCase()) +
                        " "
                    ),
                  ]
                )
              }),
              1
            ),
            _vm.listOnMap.length
              ? _c("multiselect", {
                  staticClass: "my-3 ml-3",
                  attrs: {
                    placeholder: "Find an enduser",
                    options: _vm.listOnMap,
                    "custom-label": _vm.nameWithId,
                    label: "name",
                    "track-by": "name",
                  },
                  model: {
                    value: _vm.selectedEnduser,
                    callback: function ($$v) {
                      _vm.selectedEnduser = $$v
                    },
                    expression: "selectedEnduser",
                  },
                })
              : _vm._e(),
            _vm.selectedEnduser
              ? _c("ul", { staticClass: "endusers-list" }, [
                  _c(
                    "li",
                    {
                      on: {
                        mouseover: function ($event) {
                          return _vm.setHoveredEnduser(_vm.selectedEnduser)
                        },
                        mouseleave: function ($event) {
                          return _vm.clearHoveredEnduser()
                        },
                        click: function ($event) {
                          return _vm.centerMapOnEnduser(_vm.selectedEnduser)
                        },
                      },
                    },
                    [
                      _c("p", { staticClass: "has-text-weight-bold" }, [
                        _vm._v(" " + _vm._s(_vm.selectedEnduser.name) + " "),
                      ]),
                      _vm._v(" " + _vm._s(_vm.selectedEnduser.id) + " "),
                      _c("br"),
                      _vm._v(
                        " " +
                          _vm._s(_vm.selectedEnduser.city) +
                          ", " +
                          _vm._s(_vm.selectedEnduser.country) +
                          " "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            !_vm.selectedEnduser
              ? _c(
                  "ul",
                  { staticClass: "endusers-list" },
                  _vm._l(_vm.listOnMap, function (enduser, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        on: {
                          mouseover: function ($event) {
                            return _vm.setHoveredEnduser(enduser)
                          },
                          mouseleave: function ($event) {
                            return _vm.clearHoveredEnduser()
                          },
                          click: function ($event) {
                            return _vm.centerMapOnEnduser(enduser)
                          },
                        },
                      },
                      [
                        _c("p", { staticClass: "has-text-weight-bold" }, [
                          _vm._v(
                            " " +
                              _vm._s(enduser.id) +
                              " - " +
                              _vm._s(enduser.name) +
                              " "
                          ),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(enduser.city) +
                            ", " +
                            _vm._s(enduser.country) +
                            " "
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ],
          1
        ),
        _vm.showDetailPanel && _vm.polylineData.length
          ? _c(
              "div",
              { staticClass: "column is-one-fifth" },
              [
                _c(
                  "transition",
                  { attrs: { name: "slide" } },
                  [
                    _c("CrateDetailPanel", {
                      attrs: { "trace-points": _vm.polylineData },
                      on: {
                        onClose: () => (_vm.showDetailPanel = false),
                        onFocusPoint: _vm.focusPoint,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "map-container" }, [
            _c(
              "div",
              { staticClass: "control-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "map-control" },
                  [
                    _c(
                      "b-collapse",
                      {
                        staticClass: "card",
                        attrs: {
                          open: true,
                          animation: "slide",
                          "aria-id": "openContentId1",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "trigger",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-header",
                                    attrs: {
                                      role: "button",
                                      "aria-controls": "openContentId1",
                                      "aria-expanded": props.open,
                                      expanded: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "card-header-title" },
                                      [_vm._v(" Map Control ")]
                                    ),
                                    _c(
                                      "a",
                                      { staticClass: "card-header-icon" },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: props.open
                                              ? "caret-down"
                                              : "caret-up",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("div", { staticClass: "card-content" }, [
                          _c(
                            "div",
                            { staticClass: "content" },
                            [
                              _c(
                                "b-radio",
                                {
                                  attrs: { "native-value": "si" },
                                  model: {
                                    value: _vm.type,
                                    callback: function ($$v) {
                                      _vm.type = $$v
                                    },
                                    expression: "type",
                                  },
                                },
                                [_vm._v(" SI number ")]
                              ),
                              _c(
                                "b-radio",
                                {
                                  attrs: { "native-value": "barcode" },
                                  model: {
                                    value: _vm.type,
                                    callback: function ($$v) {
                                      _vm.type = $$v
                                    },
                                    expression: "type",
                                  },
                                },
                                [_vm._v(" Barcode ")]
                              ),
                              _c("div", { staticClass: "map-select" }, [
                                _vm.type === "si"
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "b-select",
                                          {
                                            attrs: {
                                              placeholder: "Select a Si...",
                                              expanded: "",
                                            },
                                            on: { input: _vm.changeSelectedSi },
                                            model: {
                                              value: _vm.selectedSi,
                                              callback: function ($$v) {
                                                _vm.selectedSi = $$v
                                              },
                                              expression: "selectedSi",
                                            },
                                          },
                                          _vm._l(_vm.siData, function (option) {
                                            return _c(
                                              "option",
                                              {
                                                key: option.si,
                                                domProps: { value: option.si },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(option.si) + " "
                                                ),
                                              ]
                                            )
                                          }),
                                          0
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "is-flex is-flex-direction-row is-align-content-center is-justify-content-space-between mt-5",
                                          },
                                          [
                                            _c("p", { staticClass: "mr-3" }, [
                                              _vm._v(
                                                " Crates in progress: " +
                                                  _vm._s(
                                                    _vm.totalActiveCrates
                                                  ) +
                                                  " / " +
                                                  _vm._s(_vm.totalPoints) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.type === "barcode"
                                  ? _c(
                                      "div",
                                      [
                                        _c("multiselect", {
                                          attrs: {
                                            placeholder: "Select a barcode...",
                                            options: _vm.availableBarcodes,
                                            "track-by": "barcode",
                                            label: "barcode",
                                            "show-labels": false,
                                          },
                                          on: { select: _vm.onMarkerClick },
                                          model: {
                                            value: _vm.selectedDevice,
                                            callback: function ($$v) {
                                              _vm.selectedDevice = $$v
                                            },
                                            expression: "selectedDevice",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "is-flex is-flex-direction-row is-align-content-center is-justify-content-space-between mt-5",
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                "In Si: " +
                                                  _vm._s(
                                                    _vm.selectedDevice
                                                      ? _vm.selectedDevice.si
                                                      : ""
                                                  )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.type === "barcode"
                                  ? _c(
                                      "div",
                                      { staticClass: "mt-5" },
                                      [
                                        _c(
                                          "b-field",
                                          {
                                            attrs: {
                                              label: "Select date range",
                                            },
                                          },
                                          [
                                            _c(
                                              "b-datepicker",
                                              {
                                                attrs: {
                                                  "min-date": _vm.minDate,
                                                  "max-date": _vm.maxDate,
                                                  placeholder:
                                                    "Click to select...",
                                                  range: "",
                                                  "trap-focus": "",
                                                },
                                                model: {
                                                  value: _vm.dates,
                                                  callback: function ($$v) {
                                                    _vm.dates = $$v
                                                  },
                                                  expression: "dates",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "mr-auto" },
                                                  [
                                                    _c("b-button", {
                                                      attrs: {
                                                        label: "View all",
                                                      },
                                                      on: {
                                                        click: _vm.viewAll,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-5 buttons is-flex is-justify-content-space-between",
                                  },
                                  [
                                    _c(
                                      "b-tooltip",
                                      {
                                        attrs: {
                                          label: "Please select one crate ",
                                          position: "is-bottom",
                                          multilined: "",
                                        },
                                      },
                                      [
                                        _vm.type === "barcode"
                                          ? _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  type: "is-primary",
                                                  disabled:
                                                    !_vm.selectedDevice ||
                                                    !_vm.dates.length,
                                                },
                                                on: { click: _vm.onApplyDate },
                                              },
                                              [_vm._v(" Apply ")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-button",
                                      { on: { click: _vm.clearAndCenterMap } },
                                      [_vm._v(" Clear map ")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "b-button",
                  {
                    staticClass: "map-button card-header-title",
                    on: { click: () => (_vm.showTable = true) },
                  },
                  [_vm._v(" Table ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { height: "90vh" } },
              [
                _c(
                  "l-map",
                  {
                    ref: "trackMapRef",
                    staticStyle: { height: "90vh" },
                    attrs: { zoom: _vm.zoomLevel },
                  },
                  [
                    _c("l-control-layers", { attrs: { position: "topright" } }),
                    _vm._l(_vm.baseLayers, function (layer) {
                      return _c("l-tile-layer", {
                        key: layer.name,
                        attrs: {
                          name: layer.name,
                          visible: layer.visible,
                          url: layer.url,
                          "layer-type": "base",
                        },
                      })
                    }),
                    _c("l-polyline", {
                      attrs: {
                        "lat-lngs": _vm.polylineData.map((p) => p.coords),
                        color: "#15261f",
                      },
                    }),
                    _vm._l(_vm.polylineData, function (point, index) {
                      return _c(
                        "l-marker",
                        {
                          key: index,
                          attrs: {
                            "lat-lng": point.coords,
                            icon: _vm.createCustomIcon(point, index),
                            "z-index-offset": 2999,
                          },
                          on: {
                            mouseover: _vm.openPopup,
                            mouseout: _vm.closePopup,
                          },
                        },
                        [
                          _c(
                            "l-popup",
                            {
                              key: index,
                              ref: "popups",
                              refInFor: true,
                              attrs: { options: _vm.popupOptions },
                            },
                            [
                              _c("p", [
                                _c("strong", [
                                  _vm._v("Crate: " + _vm._s(point.barcode)),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _c("strong", [
                                  _vm._v("SI: " + _vm._s(_vm.selectedSi)),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(
                                  " Device: " +
                                    _vm._s(_vm.selectedDevice.shortQrTopCasing)
                                ),
                                _c("br"),
                                _vm._v(
                                  " Time: " +
                                    _vm._s(
                                      point.timestamp
                                        ? new Date(
                                            point.timestamp
                                          ).toLocaleString()
                                        : "unknown"
                                    )
                                ),
                                _c("br"),
                                _vm._v(
                                  " Battery: " +
                                    _vm._s(
                                      point.battery
                                        ? point.battery + "%"
                                        : "unknown"
                                    ) +
                                    " " +
                                    _vm._s(
                                      point.battery && point.battery === "0"
                                        ? " (no real-time positioning)"
                                        : ""
                                    )
                                ),
                                _c("br"),
                                _vm._v(
                                  " Position type: " +
                                    _vm._s(point.locationMethod)
                                ),
                                _c("br"),
                                _vm._v(
                                  " Temperature: " +
                                    _vm._s(point.temperature || "unknown") +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    _vm.showCrateMarkers
                      ? _c(
                          "l-marker-cluster",
                          { attrs: { "z-index-offset": 9999 } },
                          _vm._l(_vm.points, function (p, index) {
                            return _c(
                              "l-marker",
                              {
                                key: index,
                                attrs: {
                                  "lat-lng": p.coords,
                                  icon: _vm.generateIcon({
                                    backgroundColor: p.lastSeenBattery
                                      ? p.lastSeenBattery > 10
                                        ? "55987e"
                                        : "d0312d"
                                      : "55987e",
                                    iconSize: [52, 50],
                                  }),
                                  "z-index-offset": 3000,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onMarkerClick(p)
                                  },
                                  mouseover: _vm.openPopup,
                                  mouseout: _vm.closePopup,
                                },
                              },
                              [
                                _c("l-popup", [
                                  _c("p", [
                                    _c("strong", [_vm._v("Crate:")]),
                                    _vm._v(" " + _vm._s(p.barcode)),
                                    _c("br"),
                                    _c("strong", [
                                      _vm._v("SI: " + _vm._s(p.si)),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(
                                      " Device: " + _vm._s(p.shortQrTopCasing)
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " Last update: " +
                                        _vm._s(
                                          p.lastUpdated
                                            ? new Date(
                                                p.lastUpdated
                                              ).toLocaleString()
                                            : "unknown"
                                        )
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " Battery: " +
                                        _vm._s(
                                          p.lastSeenBattery
                                            ? p.lastSeenBattery + "%"
                                            : "unknown"
                                        ) +
                                        _vm._s(
                                          p.lastSeenBattery &&
                                            p.lastSeenBattery === "0"
                                            ? " (no real-time positioning)"
                                            : ""
                                        )
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " Temperature: " +
                                        _vm._s(p.temperature || "unknown")
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " Position type: " +
                                        _vm._s(p.locationMethod)
                                    ),
                                    _c("br"),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _vm._e(),
                    Object.values(_vm.switchStates).some((s) => s === true)
                      ? _c(
                          "div",
                          _vm._l(_vm.listOnMap, function (enduser, index) {
                            return _c(
                              "l-marker",
                              {
                                key: index,
                                attrs: {
                                  "lat-lng": [...enduser.coords],
                                  icon: _vm.generateIcon({
                                    backgroundColor: _vm.getIconColor(enduser, {
                                      hover: _vm.hoveredEnduser === enduser,
                                    }),
                                    icon: _vm.getIcon(enduser),
                                    iconSize: [40, 38],
                                  }),
                                  "z-index-offset": 2000,
                                },
                                on: {
                                  mouseover: _vm.openPopup,
                                  mouseout: _vm.closePopup,
                                  click: function ($event) {
                                    return _vm.centerMapOnEnduser(enduser)
                                  },
                                },
                              },
                              [
                                _c(
                                  "l-popup",
                                  {
                                    key: index,
                                    ref: "popups",
                                    refInFor: true,
                                    attrs: { options: _vm.popupOptions },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(" " + _vm._s(enduser.name) + " "),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "b-modal",
        {
          staticStyle: { "z-index": "1001" },
          attrs: { active: _vm.showTable, scroll: "keep" },
          on: {
            "update:active": function ($event) {
              _vm.showTable = $event
            },
          },
        },
        [
          _c("TabelView", {
            attrs: { "si-data": _vm.siData, customer: _vm.selectedCustomer },
            on: { onSelectRow: _vm.selectBarcodeFromTable },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }